import {Component, Input, OnInit} from '@angular/core';
import {Institution} from '../../enum/Institution';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  Institution = Institution;
  @Input() institution?: Institution;

  constructor() { }

  ngOnInit(): void {
  }

}
